{
  "familyId": "SPR-WEET-D-T-ERROR",
  "questions": [
    {
      "id": "SPR-WEET-D-T-ERR-001",
      "familyId": "SPR-WEET-D-T-ERROR",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_error_spotting",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst en verbeter ze:",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De hont rende door het bos. Hij vont een groot nest achter de struik en bracht het naar zijn baasje op het pad.",
        "errors": [
          {
            "word": "hont",
            "position": 1,
            "correction": "hond",
            "rule": "Hond eindigt op 'd' (meervoud: honden — je hoort de 'd')"
          },
          {
            "word": "vont",
            "position": 7,
            "correction": "vond",
            "rule": "Vond eindigt op 'd' (meervoud: vonden — je hoort de 'd')"
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "D of T aan het einde?",
            "content": "Maak het woord langer (meervoud of verbuiging). Hoor je een 'd'? Dan schrijf je 'd'. Voorbeeld: hond → honden (je hoort 'd'). Woorden als 'nest' (nesten → t) en 'bos' (bossen → s) zijn wél goed!",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_fouten_zoeken",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Er staan 2 fouten in de tekst. 'Hont' moet 'hond' zijn (honden — je hoort 'd'). 'Vont' moet 'vond' zijn (vonden — je hoort 'd'). De andere woorden zijn goed: 'bos' (bossen → s), 'nest' (nesten → t), 'bracht' (correct verleden tijd).",
        "solutionSteps": [
          "Fout 1: 'hont' → 'hond' (honden — je hoort de 'd')",
          "Fout 2: 'vont' → 'vond' (vonden — je hoort de 'd')",
          "Geen fout: 'bos', 'nest', 'bracht', 'pad' zijn correct ✓"
        ],
        "distractorExplanations": {
          "hont": "Goed gevonden! 'Hont' moet 'hond' zijn. Maak het meervoud: honden — je hoort de 'd'.",
          "vont": "Goed gevonden! 'Vont' moet 'vond' zijn. Maak het meervoud: vonden — je hoort de 'd'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    },
    {
      "id": "SPR-WEET-D-T-ERR-002",
      "familyId": "SPR-WEET-D-T-ERROR",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_error_spotting",
      "questionType": "sentence_error_judge",
      "question": "Welke zin bevat een spelfout?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "De kat sliep op het bed.", "hasError": false, "explanation": "'Bed' is correct: bedden → je hoort 'd'. 'Kat' is correct: katten → je hoort 't'." },
          { "text": "Het kint speelde in de tuin.", "hasError": true, "correction": "Het kind speelde in de tuin.", "explanation": "'Kint' moet 'kind' zijn. Maak het meervoud: kinderen — je hoort de 'd'." },
          { "text": "Mijn jas hangt aan de kapstok.", "hasError": false, "explanation": "'Jas' en 'kapstok' zijn correct gespeld." },
          { "text": "De bal rolde over het gras.", "hasError": false, "explanation": "'Bal' (ballen → l) en 'gras' (grassen → s) zijn correct." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "D of T? Maak het woord langer!",
            "content": "Twijfel je? Maak het woord langer. 'Kint' → kinderen. Je hoort 'd', dus je schrijft 'kind'. Bij 'bed' → bedden (je hoort 'd'). Bij 'kat' → katten (je hoort 't').",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_zin_herkennen",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Zin 2 bevat de fout: 'kint' moet 'kind' zijn. Maak het meervoud: kinderen — je hoort duidelijk de 'd'. Regel: twijfel je over d of t? Maak het woord langer en luister goed.",
        "solutionSteps": [
          "Controleer elk woord met d/t aan het eind",
          "'kint' → kinderen → je hoort 'd' → schrijf 'kind'",
          "De andere woorden zijn correct gespeld ✓"
        ],
        "distractorExplanations": {
          "0": "'Bed' is correct: bedden → je hoort 'd'. 'Kat' is correct: katten → je hoort 't'.",
          "1": "Goed! 'Kint' moet 'kind' zijn. Kinderen — je hoort de 'd'.",
          "2": "'Jas' en 'kapstok' zijn correct gespeld.",
          "3": "'Bal' (ballen → l) en 'gras' (grassen → s) zijn correct."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.d-t-correct-marked-wrong", "label": "Correct woord als fout aangewezen", "optionIndex": 0 },
          { "id": "spr.d-t-correct-marked-wrong", "label": "Correct woord als fout aangewezen", "optionIndex": 2 },
          { "id": "spr.d-t-correct-marked-wrong", "label": "Correct woord als fout aangewezen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-ERR-003",
      "familyId": "SPR-WEET-D-T-ERROR",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_error_spotting",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst en verbeter ze:",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Het paard galoppeerde over het lant. De ruiter hielt de teugels stevig vast en reed langs het wout naar de stad.",
        "errors": [
          {
            "word": "lant",
            "position": 6,
            "correction": "land",
            "rule": "Land eindigt op 'd' (meervoud: landen — je hoort de 'd')"
          },
          {
            "word": "hielt",
            "position": 8,
            "correction": "hield",
            "rule": "Hield eindigt op 'd' (verleden tijd van houden: hielden — je hoort de 'd')"
          },
          {
            "word": "wout",
            "position": 17,
            "correction": "woud",
            "rule": "Woud eindigt op 'd' (meervoud: wouden — je hoort de 'd')"
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "syllableBlocks",
          "showWhen": "wrong",
          "data": {
            "word": "landen",
            "syllables": ["lan", "den"],
            "types": ["closed", "closed"],
            "label": "land → landen (je hoort de 'd')"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Moeilijke d/t-woorden",
            "content": "Sommige woorden klinken als 't' maar schrijf je met 'd'. Truc: maak het woord langer. Land → landen (d). Hield → hielden (d). Woud → wouden (d). Let op: 'paard' (paarden → d) en 'stad' (steden → d) zijn hier wél goed!",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_moeilijk",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Er staan 3 fouten in de tekst. 'Lant' → 'land' (landen → d). 'Hielt' → 'hield' (hielden → d). 'Wout' → 'woud' (wouden → d). De andere woorden zijn correct: 'paard' (paarden → d), 'stad' (steden → d), 'vast' (correct).",
        "solutionSteps": [
          "Fout 1: 'lant' → 'land' (landen — je hoort de 'd')",
          "Fout 2: 'hielt' → 'hield' (hielden — je hoort de 'd')",
          "Fout 3: 'wout' → 'woud' (wouden — je hoort de 'd')",
          "Correct: 'paard', 'stad', 'vast' ✓"
        ],
        "distractorExplanations": {
          "lant": "Goed gevonden! 'Lant' moet 'land' zijn. Landen — je hoort de 'd'.",
          "hielt": "Goed gevonden! 'Hielt' moet 'hield' zijn. Hielden — je hoort de 'd'.",
          "wout": "Goed gevonden! 'Wout' moet 'woud' zijn. Wouden — je hoort de 'd'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    },
    {
      "id": "SPR-WEET-D-T-ERR-004",
      "familyId": "SPR-WEET-D-T-ERROR",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_error_spotting",
      "questionType": "sentence_error_judge",
      "question": "Welke zin bevat een spelfout?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "De schildpad kroop over het pad.", "hasError": false, "explanation": "'Schildpad' (schildpadden → d) en 'pad' (paden → d) zijn correct." },
          { "text": "Het geboud stond aan de gracht.", "hasError": true, "correction": "Het gebouw stond aan de gracht.", "explanation": "'Geboud' moet 'gebouw' zijn. Maak het meervoud: gebouwen — je hoort de 'w', niet de 'd'." },
          { "text": "De mand stond vol met fruit.", "hasError": false, "explanation": "'Mand' is correct. Meervoud: manden — je hoort de 'd'." },
          { "text": "Het riet wuifde in de wind.", "hasError": false, "explanation": "'Riet' (rieten → t) en 'wind' (winden → d) zijn correct." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "syllableBlocks",
          "showWhen": "wrong",
          "data": {
            "word": "gebouwen",
            "syllables": ["ge", "bou", "wen"],
            "types": ["open", "closed", "closed"],
            "label": "gebouw → gebouwen (je hoort 'w', niet 'd')"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lastige eindletters",
            "content": "Geboud is fout. Maak het meervoud: gebouwen. Je hoort een 'w', dus je schrijft 'gebouw'. Let op: 'schildpad' (schildpadden → d) en 'pad' (paden → d) zijn correct!",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_herkennen_mc",
      "variantIndex": 1,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Geboud' is fout. Het juiste woord is 'gebouw'. Regel: maak het woord langer — gebouwen. Je hoort een 'w', geen 'd'. De andere woorden zijn correct: schildpad (schildpadden → d), mand (manden → d), riet (rieten → t).",
        "solutionSteps": [
          "Controleer: geboud → gebouwen → je hoort 'w' → schrijf 'gebouw'",
          "Schildpad → schildpadden → correct (d)",
          "Mand → manden → correct (d)",
          "Riet → rieten → correct (t) ✓"
        ],
        "distractorExplanations": {
          "0": "'Schildpad' (schildpadden → d) en 'pad' (paden → d) zijn correct.",
          "1": "Goed! 'Geboud' moet 'gebouw' zijn. Gebouwen — je hoort de 'w'.",
          "2": "'Mand' is correct. Meervoud: manden — je hoort de 'd'.",
          "3": "'Riet' is correct. Meervoud: rieten — je hoort de 't'. 'Wind' (winden → d) is ook correct."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.d-t-correct-marked-wrong", "label": "Correct woord als fout aangewezen", "optionIndex": 0 },
          { "id": "spr.d-t-w-confusion", "label": "D/w-verwarring niet herkend", "optionIndex": 2 },
          { "id": "spr.d-t-correct-marked-wrong", "label": "Correct woord als fout aangewezen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-ERR-005",
      "familyId": "SPR-WEET-D-T-ERROR",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_error_spotting",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst en verbeter ze:",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De jeugd speelde op het velt. Een kint trapte de bal over het hek en die rolde tot aan de rant van de sloot.",
        "errors": [
          {
            "word": "velt",
            "position": 5,
            "correction": "veld",
            "rule": "Veld eindigt op 'd' (meervoud: velden — je hoort de 'd')"
          },
          {
            "word": "kint",
            "position": 7,
            "correction": "kind",
            "rule": "Kind eindigt op 'd' (meervoud: kinderen — je hoort de 'd')"
          },
          {
            "word": "rant",
            "position": 18,
            "correction": "rand",
            "rule": "Rand eindigt op 'd' (meervoud: randen — je hoort de 'd')"
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "D of T? Maak het woord langer!",
            "content": "Maak het meervoud of een verbuiging. Hoor je een 'd'? Schrijf 'd'. Veld → velden (d). Kind → kinderen (d). Rand → randen (d). 'Jeugd' (jeugdig → d) en 'sloot' (sloten → t) zijn correct!",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_fouten_drie",
      "variantIndex": 1,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Er staan 3 fouten in de tekst. 'Velt' → 'veld' (velden → d). 'Kint' → 'kind' (kinderen → d). 'Rant' → 'rand' (randen → d). Correct: 'jeugd' (jeugdig → d), 'hek' (hekken → k), 'sloot' (sloten → t).",
        "solutionSteps": [
          "Fout 1: 'velt' → 'veld' (velden — je hoort de 'd')",
          "Fout 2: 'kint' → 'kind' (kinderen — je hoort de 'd')",
          "Fout 3: 'rant' → 'rand' (randen — je hoort de 'd')",
          "Correct: 'jeugd', 'hek', 'sloot' ✓"
        ],
        "distractorExplanations": {
          "velt": "Goed gevonden! 'Velt' moet 'veld' zijn. Velden — je hoort de 'd'.",
          "kint": "Goed gevonden! 'Kint' moet 'kind' zijn. Kinderen — je hoort de 'd'.",
          "rant": "Goed gevonden! 'Rant' moet 'rand' zijn. Randen — je hoort de 'd'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    },
    {
      "id": "SPR-WEET-D-T-ERR-006",
      "familyId": "SPR-WEET-D-T-ERROR",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_error_spotting",
      "questionType": "sentence_error_judge",
      "question": "Welke zin bevat een spelfout?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Het paard stond in de wei.", "hasError": false, "explanation": "'Paard' is correct. Meervoud: paarden — je hoort de 'd'." },
          { "text": "De hond blaft naar de postbode.", "hasError": false, "explanation": "'Hond' is correct. Meervoud: honden — je hoort de 'd'." },
          { "text": "Het kint fietst naar school.", "hasError": true, "correction": "Het kind fietst naar school.", "explanation": "'Kint' moet 'kind' zijn. Kinderen — je hoort de 'd'." },
          { "text": "De wind waait door de bomen.", "hasError": false, "explanation": "'Wind' is correct. Meervoud: winden — je hoort de 'd'." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "D of T? Maak het woord langer!",
            "content": "Twijfel je? Maak het woord langer. 'Kint' → kinderen. Je hoort 'd', dus je schrijft 'kind'. 'Paard' (paarden → d), 'hond' (honden → d) en 'wind' (winden → d) zijn correct!",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_zin_herkennen_2",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Zin 3 bevat de fout: 'kint' moet 'kind' zijn. Regel: maak het woord langer — kinderen. Je hoort de 'd'. De andere woorden zijn correct: paard (paarden → d), hond (honden → d), wind (winden → d).",
        "solutionSteps": [
          "Controleer elk woord met d/t aan het eind",
          "'kint' → kinderen → je hoort 'd' → schrijf 'kind'",
          "'paard', 'hond', 'wind' zijn correct ✓"
        ],
        "distractorExplanations": {
          "0": "'Paard' is correct. Meervoud: paarden — je hoort de 'd'.",
          "1": "'Hond' is correct. Meervoud: honden — je hoort de 'd'.",
          "2": "Goed! 'Kint' moet 'kind' zijn. Kinderen — je hoort de 'd'.",
          "3": "'Wind' is correct. Meervoud: winden — je hoort de 'd'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.d-t-correct-marked-wrong", "label": "Correct woord als fout aangewezen", "optionIndex": 0 },
          { "id": "spr.d-t-correct-marked-wrong", "label": "Correct woord als fout aangewezen", "optionIndex": 1 },
          { "id": "spr.d-t-correct-marked-wrong", "label": "Correct woord als fout aangewezen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-ERR-007",
      "familyId": "SPR-WEET-D-T-ERROR",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_error_spotting",
      "questionType": "fill_in",
      "question": "Schrijf het woord goed: het ... (rijmt op 'bont') van het huis is rood. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["rond"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Maak het woord langer!", "content": "'Rond' eindigt op 'd'. Maak het langer: ronde — je hoort de 'd'. Dus schrijf je 'rond', niet 'ront'. Onthoud: maak het woord langer om te horen of het d of t is.", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_fill_rond",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Rond' schrijf je met een 'd'. Maak het woord langer: ronde — je hoort duidelijk de 'd'. Dus het is 'rond', niet 'ront'. Andere voorbeelden: hond (honden → d), veld (velden → d), kind (kinderen → d).",
        "solutionSteps": [
          "Het woord rijmt op 'bont' → rond",
          "Twijfel je over d of t? Maak het langer: ronde",
          "Je hoort 'd' → schrijf 'rond'"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    }
  ]
}